import { Routes, Route } from "react-router-dom";
import Experience from "./pages/Experience";
import Home from "./pages/Home";
import About from "./pages/About";
import ComingSoon from "./pages/ComingSoon";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/riffle-systems" element={<ComingSoon />} />
        <Route path="/apparel" element={<ComingSoon />} />
        <Route path="/experience" element={<Experience />} />
        <Route path="/about" element={<About />} />
      </Routes>
    </>
  );
}

export default App;
